import React from 'react';
import { Card, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccCurrentWork } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const WorkstationCurrentWorkMonitor: React.FC<Props> = ({ params }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useWccCurrentWork(params);
  const rows = (data as { rows?: Record<string, unknown>[] })?.rows ?? [];

  return (
    <Card id="current-work" title="Current work monitor" style={{ marginTop: 16 }}>
      <Table
        size="small"
        loading={isLoading}
        rowKey={(r) => `${r.workstation_id}-${r.work_order_id}`}
        dataSource={rows}
        onRow={(r) => ({
          onClick: () => r.deepLink && navigate(String(r.deepLink)),
          style: { cursor: 'pointer' },
        })}
        columns={[
          { title: 'Workstation', dataIndex: 'workstation_name' },
          { title: 'WO', dataIndex: 'work_order_number', width: 100 },
          { title: 'Item', dataIndex: 'item_name', ellipsis: true },
          { title: 'Line', dataIndex: 'line_item_description', ellipsis: true },
          { title: 'Unit', dataIndex: 'production_unit_number', width: 60 },
          { title: 'Operation', dataIndex: 'operation' },
          { title: 'Scope', dataIndex: 'execution_scope', width: 110 },
          { title: 'Operator', dataIndex: 'operator_name' },
          { title: 'Planned h', dataIndex: 'planned_hours', width: 80 },
          { title: 'Actual h', dataIndex: 'actual_hours', width: 80 },
        ]}
        pagination={{ pageSize: 15 }}
      />
    </Card>
  );
};

export default WorkstationCurrentWorkMonitor;
